import React from 'react';
import { UserViewModel } from './UserToolbarViewModel';
import { SetupUIBindingForReactFunctionalComponent } from '../common/UIBinding';

export function UserToolbar(props: { viewModel: UserViewModel }) {
    let viewModel = props.viewModel;
    SetupUIBindingForReactFunctionalComponent(props.viewModel);

    if (viewModel.appService.userModel) {
        return <>
            <button className='user-profile' onClick={()=>viewModel.goToUserProfile()}>{viewModel.appService.userModel.nickname}</button>
            <button onClick={()=>viewModel.goToKeyboardCode()}>Keyboard Code</button>
            <button onClick={() => viewModel.signOut()} style={{ marginLeft: '10px', minWidth: 'auto' }}>Sign Out</button>
        </>;
    }

    return <><button onClick={() => viewModel.signUp()}>Sign Up</button><button onClick={() => viewModel.signIn()}>Sign In</button></>;
}
